import { render, staticRenderFns } from "./pushBox.vue?vue&type=template&id=4cf849ef&scoped=true&lang=html&"
import script from "./pushBox.vue?vue&type=script&lang=js&"
export * from "./pushBox.vue?vue&type=script&lang=js&"
import style0 from "./pushBox.vue?vue&type=style&index=0&id=4cf849ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf849ef",
  null
  
)

component.options.__file = "pushBox.vue"
export default component.exports